import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const addressApi = createApi({
  reducerPath: 'addressApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.utkarsita.com/api/v1',
    // prepareHeaders: async (headers, { getState }) => {
    //   headers.set('Content-Type', 'application/json');
    //   return headers;
    // },
    credentials: 'include',
  }),
  tagTypes: ['Address'],
  endpoints: (builder) => ({
    
    addAddress: builder.mutation({
        query: (body) => {
          console.log('Payload received in mutation:', body); // Log the payload here
          return {
            url: '/address/add-address',
            method: 'POST',
            body,
          };
        },
      }),
      
  }),
});

export const {
  useAddAddressMutation
} = addressApi;
